import Vue from 'vue';

/**
 * Array of plugins to autoload
 *
 * @type {object}
 */
export const plugins = [];

/**
 * Load plugins
 */
export function loader() {
    plugins.forEach((plugin) => plugin(Vue));
}
